var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlagEn = function SvgFlagEn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 12"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#flag-en_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#flag-en_svg__b)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v12H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E42A5",
    fillRule: "evenodd",
    d: "M0 0v12h16V0z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "flag-en_svg__c",
    width: 16,
    height: 12,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M0 0v12h16V0z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#flag-en_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m-1.782 11.143 3.521 1.489L16.08 1.619l1.858-2.213-3.765-.497-5.85 4.745-4.707 3.198z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F50100",
    d: "m-1.3 12.186 1.794.864L17.27-.8h-2.518z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m17.782 11.143-3.521 1.489L-.08 1.619-1.938-.594l3.765-.497 5.85 4.745 4.707 3.198z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F50100",
    d: "m17.661 11.891-1.793.864-7.144-5.93-2.118-.662-8.722-6.75H.403l8.717 6.59 2.316.795z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "flag-en_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.889-1H6.11v5H-.986v4H6.11v5H9.89V8h7.125V4H9.889z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F50100",
    fillRule: "evenodd",
    d: "M9.889-1H6.11v5H-.986v4H6.11v5H9.89V8h7.125V4H9.889z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.111-1v-1h-1v1zM9.89-1h1v-1h-1zM6.11 4v1h1V4zM-.986 4V3h-1v1zm0 4h-1v1h1zM6.11 8h1V7h-1zm0 5h-1v1h1zm3.778 0v1h1v-1zm0-5V7h-1v1zm7.125 0v1h1V8zm0-4h1V3h-1zM9.889 4h-1v1h1zM6.11 0H9.89v-2H6.11zm1 4v-5h-2v5zM-.986 5H6.11V3H-.986zm1 3V4h-2v4zM6.11 7H-.986v2H6.11zm1 6V8h-2v5zm2.778-1H6.11v2H9.89zm-1-4v5h2V8zm8.125-1H9.889v2h7.125zm-1-3v4h2V4zM9.889 5h7.125V3H9.889zm-1-6v5h2v-5z",
    mask: "url(#flag-en_svg__d)"
  }))))), /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 11,
    x: 0.5,
    y: 0.5,
    stroke: "#000",
    strokeOpacity: 0.1,
    rx: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "flag-en_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 12,
    fill: "#fff",
    rx: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "flag-en_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v12H0z"
  })))));
};
export default SvgFlagEn;